<template>
  <ul qaid="nav-categories-layout" class="flex flex-col px-2 lg:flex-row lg:items-center lg:px-0">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'NavCategoriesLayout',
};
</script>
